<template>
  <div class="container">
    <div class="main-header"></div>
    <div class="header-empty-line"></div>
    <main>
      <!-- <template v-for="(item) in block_list">
        <block-video v-if="item.title=='best-videos'"
                    :key="item.title"
                    :block-data="item"></block-video>
      </template> -->
      <template v-for="(item) in block_list">
        <!-- v-if="item.title!='best-videos'" -->
        <block
              :key="item.title"
              :block-data="item"></block>
      </template>
      <right-nav></right-nav>
    </main>
    <div v-if="footer" class="footer" style="height: 306px;background: #fff"></div>
  </div>
</template>

<script>

import BlockVideo from '../components/Block-Video.vue'
import Block from '../components/Block.vue'
import RightNav from '../components/Right-Nav.vue'
import block_list from '@/assets/data'

export default {
  components: {
    BlockVideo,
    Block,
    RightNav
  },
  data () {
    return {
      block_list,
      footer: process.env.NODE_ENV === 'development'
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  margin-bottom: -30px;
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
}
main{
  background: url('../../../assets/images/pc/background-1.png') no-repeat calc(50% - 540px) 40px,
  url('../../../assets/images/pc/background-2.png') no-repeat right center,
  url('../../../assets/images/pc/background-3.png') no-repeat right bottom;
  background-size: 380px auto, 201px auto, 286px auto;
  padding-bottom: 88px;
}
.main-header {
  height: 260px;
  background: url(../../../assets/images/pc/header.png) no-repeat center center;
  background-size: auto 100%;
  background-color: #000100;
}
.header-empty-line {
  height: 10px;
  background-color: #45767a;
}
</style>
